import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { Browser } from '@capacitor/browser';
import { brandingColourHeavy, newContentPadding, popupZIndex } from '../appComponents/cssConstants';
import useAppVersionCheck from '../core/api/appVersionCheck';
import Loading from './Loading';
import BottomModal from './bottomModal/BottomModal';
import ContentCard from '../appComponents/pages_v2/common/ContentCard';
import { isWebApp } from '../lib/utils';

const AppVersionGate = ({ children }: Props) => {
	const [bannerDismissed, setBannerDismissed] = useState(false);
	const data = useAppVersionCheck();

	const openStore = async () => {
		if (data?.storeUrl) await Browser.open({ url: data.storeUrl });
	};

	if (isWebApp) return children;

	if (data === undefined) return <Loading />;

	if (!data || data.status === 'ok') return children;

	if (data.status === 'force-update') {
		return <ForceUpdateScreen onUpdate={openStore} message={data.message} />;
	}

	if (data.status === 'soft-update') {
		return (
			<>
				<BottomModal
					open={!bannerDismissed}
					onClose={() => setBannerDismissed(true)}
					title="Update Available"
					body={[data.message]}
					actions={[
						{ label: 'Update Now', callback: openStore },
						{ label: 'Later', callback: () => {} }
					]}
				/>
				{children}
			</>
		);
	}

	return children;
};

export default AppVersionGate;

interface Props {
	children: React.ReactNode;
}

const ForceUpdateScreen = ({ onUpdate, message }: { onUpdate: () => void; message: string }) => (
	<ForceUpdateOverlay>
		<StyledContentCard
			title="Update Required"
			description={message}
			buttonText="Update Now"
			onButtonClick={onUpdate}
			centred
		/>
	</ForceUpdateOverlay>
);

const StyledContentCard = styled(ContentCard)`
	box-shadow: none;
`;

const ForceUpdateOverlay = styled.div`
	* {
		font-family: 'Inter', sans-serif !important;
	}

	position: fixed;
	inset: 0;
	z-index: ${popupZIndex};
	background: ${brandingColourHeavy};
	display: flex;
	align-items: center;
	justify-content: center;
	padding: ${newContentPadding};
`;
